import { Component, OnInit, inject } from "@angular/core";
import {
  FormBuilder,
  FormGroup,
  Validators,
  ReactiveFormsModule
} from "@angular/forms";
import {
  MAT_DIALOG_DATA,
  MatDialogRef,
  MatDialogContent,
  MatDialogActions
} from "@angular/material/dialog";
import { MatFormField, MatLabel, MatError } from "@angular/material/form-field";
import { MatInput } from "@angular/material/input";
import { MatButton } from "@angular/material/button";
import { CdkTextareaAutosize } from "@angular/cdk/text-field";
import { DialogHeaderComponent } from "../../shared/dialog-header/dialog-header.component";

export interface PlannerNoteDialogData {
  currentNote: string;
  ticketReference: string;
}

@Component({
  selector: "app-planner-note-edit-dialog",
  templateUrl: "./planner-note-edit-dialog.component.html",
  styleUrls: ["./planner-note-edit-dialog.component.scss"],
  imports: [
    DialogHeaderComponent,
    MatDialogContent,
    ReactiveFormsModule,
    MatFormField,
    MatLabel,
    MatInput,
    CdkTextareaAutosize,
    MatError,
    MatDialogActions,
    MatButton
  ]
})
export class PlannerNoteEditDialogComponent {
  private fb = inject(FormBuilder);
  dialogRef =
    inject<MatDialogRef<PlannerNoteEditDialogComponent>>(MatDialogRef);
  data = inject<PlannerNoteDialogData>(MAT_DIALOG_DATA);

  plannerNoteForm: FormGroup;

  constructor() {
    const data = this.data;

    this.plannerNoteForm = this.fb.group({
      noteContent: [data.currentNote?.trim() || "", [Validators.required]]
    });
  }

  onCancel(): void {
    this.dialogRef.close();
  }

  onSave(): void {
    if (this.plannerNoteForm.valid) {
      this.dialogRef.close({
        noteContent: this.plannerNoteForm.get("noteContent")?.value
      });
    }
  }

  get noteContent() {
    return this.plannerNoteForm.get("noteContent");
  }
}
